import React, { useState, useEffect } from "react";
import { Modal, Form, AutoComplete, Input, Typography } from "antd";
import { connect } from "react-redux";
import axios from "axios";

const { Text } = Typography;

const ModalMotivoPerdida = ({
  visible,
  lead,
  onCancel,
  onConfirmar,
  headersToken,
  empresaId,
}) => {
  const [motivo, setMotivo] = useState("");
  const [sugerencias, setSugerencias] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar sugerencias y limpiar estado al abrir
  useEffect(() => {
    if (visible) {
      setMotivo("");
      axios
        .post(
          "leads/obtenerMotivosPerdida",
          { empresaId },
          { headers: headersToken },
        )
        .then((res) => {
          if (res.data.success === 2) {
            setSugerencias(res.data.motivos || []);
          }
        })
        .catch(() => {});
    }
  }, [visible, empresaId, headersToken]);

  const handleConfirmar = () => {
    if (!motivo?.trim()) return;
    setLoading(true);
    // El loading lo maneja el padre al cambiar el estado
    onConfirmar(motivo.trim());
    setLoading(false);
  };

  const opcionesAutoComplete = sugerencias.map((s) => ({ value: s }));

  return (
    <Modal
      title="¿Por qué se pierde este lead?"
      visible={visible}
      okText="Marcar como Perdido"
      okButtonProps={{
        danger: true,
        disabled: !motivo?.trim(),
        loading,
      }}
      cancelText="Cancelar"
      onOk={handleConfirmar}
      onCancel={onCancel}
      destroyOnClose
    >
      <p style={{ marginBottom: 16 }}>
        <Text type="secondary">Lead: </Text>
        <Text strong>{lead?.descripcion}</Text>
      </p>

      <Form layout="vertical">
        <Form.Item
          label="Motivo de pérdida"
          required
          style={{ marginBottom: 0 }}
        >
          <AutoComplete
            options={opcionesAutoComplete}
            filterOption={(input, option) =>
              option.value.toLowerCase().includes(input.toLowerCase())
            }
            value={motivo}
            onChange={(val) => setMotivo(val)}
            style={{ width: "100%" }}
          >
            <Input.TextArea
              rows={2}
              placeholder="Ej: Sin presupuesto, Eligió competencia, Sin respuesta..."
              onPressEnter={(e) => {
                e.preventDefault();
                if (motivo?.trim()) handleConfirmar();
              }}
            />
          </AutoComplete>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalMotivoPerdida);
